import { env } from '@/env';
import { ContactInfo } from '@/types/contact';

export const contactInfo: ContactInfo = {
  email: env.NEXT_PUBLIC_CONTACT_EMAIL,
  phone: env.NEXT_PUBLIC_CONTACT_PHONE,
  hours: env.NEXT_PUBLIC_CONTACT_HOURS,
};
